import styled from "styled-components";
import tw from "twin.macro";

export const Wrapper = styled.div`
  color: var(--grey-9);

  display: flex;
  align-items: flex-start;
  height: 100vh;
`;

export const Content = styled.div``;

export const ContentHeader = styled.div``;

export const ContentBody = styled.div``;
